import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'lgr-slide',
  styleUrl: 'slide.scss',
  shadow: false,
})
export class Slide {

  /**
   * Background of text.
   */
  @Prop({ reflect: true }) textBackground: boolean = true;
  /**
   * Image source of slide's background image.
   */
  @Prop({ reflect: true }) imageSrc?: string;
  /**
   * 
   */
  @Prop({ reflect: true }) gradient: boolean = true;

  render() {
    return (
      <Host
        class='swiper-slide'
        style={{
          'background': `
            ${this.gradient ? 'linear-gradient(90deg, rgba(51, 51, 51, 0.50) 0%, rgba(51, 51, 51, 0.00) 88.77%), ' : ''}
            ${this.imageSrc !== "" ? `url(${this.imageSrc}) center / cover no-repeat ` : ''}
          `
        }}
      >
        <div class={{
          'container-background': this.textBackground
        }}>
          <slot name='text' />
        </div>
        <div>
          <slot name='button' />
        </div>
      </Host>
    );
  }

}
